// Sentry first, so it catches errors from everything imported after it.
import "./sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Pages listed in src/seo.js ship pre-rendered HTML; attach to it instead of
// re-rendering. Other routes are served an empty shell and render normally.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
